<template>
  <div class="transit-item grid-item" :style="{ color, borderColor: color }">
    <div class="time">
      <strong>{{ minutes }}</strong> min
    </div>
    
    <div class="destination">
      To {{ destinationLabel }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TransitItem',
    props: {
      time: { type: Number, default: 0, required: true }, // seconds
      destinationLabel: { type: String, default: '', required: true }
    },
    computed: {
      minutes () {
        return Math.ceil(this.time / 60)
      },
      color () {
        return '#' + (this.$route.params.color || 'FFFFFF')
      }
    }
  }
</script>

<style>

  @media screen and (max-width: 3839px) {
    .panels-grid .transit-item {
      padding-top: 20px;
      position: relative;
      text-transform: uppercase;
    }
    .transit-item .time {
      font-size: 33px;
      font-weight: bold;
      margin-left: 5px;
      margin-top:20px;
    }

    .transit-item .time strong {
      font-size: 105px;
    }

    .transit-item .destination {
      font-size: 22px;
      margin-left:5px;
      margin-top:12px;
    }

    .transit-item .direction {
      font-size: 20px;
      position: absolute;
      margin-left:5px;
      bottom:20px;
      font-weight: normal;
    }
  }
  @media screen and (min-width: 3840px) {
    .panels-grid .transit-item {
      padding-top: 40px;
      position: relative;
      text-transform: uppercase;
    }
    .transit-item .time {
      font-size: 66px;
      font-weight: bold;
      margin-left: 10px;
      margin-top:40px;
    }

    .transit-item .time strong {
      font-size: 210px;
    }

    .transit-item .destination {
      font-size: 25px;
      margin-left:25px;
      margin-top:25px;
    }

    .transit-item .direction {
      font-size: 20px;
      position: absolute;
      margin-left:25px;
      bottom:60px;
      font-weight: normal;
    }
  }
</style>